<app-layout-header></app-layout-header>
<div class="router-outlet-wrapper">
  <div class="router-outlet-container">
    <router-outlet></router-outlet>
  </div>
</div>
<p-toast></p-toast>
